import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const FinancialReportsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/financial/billsToPay`);
    }
  }, [match]);

  return null;
};

export default FinancialReportsPage;
